<template>
  
  <div class="group" ref="hingedDoorsGroup">

    <div class="group-header">
      <div class="group-title" :id="`${builder.hingedDoors.fieldName}Title`">What door configuration would you like?</div>
    </div>

    <div style="margin-bottom: 20px;" v-if="builder.currentItemDoorCount">A <span v-html="builder.currentItemDoorCount"></span> door hinged wardrobe is best for your space. Each door panel will be <span v-html="builder.currentItemDoorWidth"></span>mm.</div>

    <!-- <Selector
      :key=builder.hingedDoors.fieldName
      :field-name=builder.hingedDoors.fieldName
      :display-type=builder.hingedDoors.displayType
      :options=builder.hingedDoors.options
      :selected=builder.currentItem.specs[builder.hingedDoors.fieldName]
      options-source="hingedDoorsOptions"
      scope="specs"
      @select-option="select"
    ></Selector> -->

    <Selector
      :key=builder.productLayouts.fieldName
      :field-name=builder.productLayouts.fieldName
      :display-type=builder.hingedHeights.displayType
      :selected=builder.currentItem[builder.productLayouts.fieldName]
      options-source="hingedWardrobeLayoutOptions"
      @select-option="selectProductLayout"
    ></Selector>

  </div>
  
</template>

<script setup>
  
import { ref, computed } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);
}

function selectProductLayout(prop, opt) {
  builder.setCurrentItemProp(prop, opt['id']);
}

let doorsWidth = 0;

if (builder.hingedWardrobeLayoutOptions.length == 1) {
    builder.setCurrentItemProp(builder.productLayouts.fieldName, builder.hingedWardrobeLayoutOptions[0]['id']);
    console.log(builder.hingedWardrobeLayoutOptions[0]);
}

// init refs
const hingedDoorsGroup = ref(null);
builder.refs['hingedDoorsGroup'] = hingedDoorsGroup;
</script>